import { render, staticRenderFns } from "./AlertTypeEditor.vue?vue&type=template&id=1f62bb02&scoped=true"
import script from "./AlertTypeEditor.vue?vue&type=script&lang=js"
export * from "./AlertTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f62bb02",
  null
  
)

export default component.exports